export default __webpack_public_path__ + "b16b3d097812c35271182b7f3b242d50.png";